export function stringToColor(string) {
    let hash = 0;
    let i;
    
    if (string.length === 1 ){
        return '#C4CDD5';
    }
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.substr(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
  }
  
  export function stringAvatar(name) {
    if (name.length === 1){
        return 
    }
    // eslint-disable-next-line
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name[0].toUpperCase()}${name[1].toUpperCase()}`,
    };
  }

  export const formatPersonnel = (data) => {
    const result = []
    data.forEach(item => {
      const row = {id: item.email, display: `${item.first_name} ${item.last_name}`}
      result.push(row)
    })
    return result
  } 